/**
 * Virtual to-do tags are derived by the Navigator API at read time. They can
 * be used as filters, but must never be persisted through a to-do PATCH.
 */
export const COMPASSUS_RESCHEDULE_TODO_TAG = "reschedule";

export const isCompassusVirtualTodoTag = (tag: string): boolean =>
  tag.trim().toLowerCase() === COMPASSUS_RESCHEDULE_TODO_TAG;

export const stripCompassusVirtualTodoTags = (tags: string[]): string[] =>
  tags.filter((tag) => !isCompassusVirtualTodoTag(tag));

export const withCompassusRescheduleTodoOption = (
  options: string[]
): string[] => {
  const withoutDuplicate = options.filter(
    (option) => !isCompassusVirtualTodoTag(option)
  );
  return [COMPASSUS_RESCHEDULE_TODO_TAG, ...withoutDuplicate];
};
